import { deserializeCart, serializeCart } from '../helper/addToCart';

import { apiFetch } from '../helper/apiClient';



export async function applyCoupon(couponCode, cart) {

  const code = (couponCode || "").trim().toUpperCase();

  if (!code) {

    return { success: false, message: "Enter a coupon code." };

  }



  try {

    const response = await apiFetch(

      "coupon/apply",

      {

        method: "POST",

        body: JSON.stringify({

          code,

          products: serializeCart(cart),

        }),

      },

      { auth: true }

    );



    const data = await response.json();



    if (!response.ok) {

      return {

        success: false,

        message: data.detail || "The coupon you provided is not valid.",

      };

    }



    return {

      success: true,

      cart: deserializeCart(data.products),

      appliedTotal: data.applied_total,

      originalTotal: data.original_total,

      discountAmount: data.discount_amount || 0,

      flatDiscount: data.flat_discount || 0,

      couponCode: data.coupon || code,

      message: `Coupon "${data.coupon || code}" applied successfully.`,

    };

  } catch (error) {

    return {

      success: false,

      message: "An error occurred while applying the coupon.",

      error: error.message,

    };

  }

}

